import { render, staticRenderFns } from "./AppCopyUrl.vue?vue&type=template&id=35a77dcf&scoped=true"
import script from "./AppCopyUrl.vue?vue&type=script&lang=js"
export * from "./AppCopyUrl.vue?vue&type=script&lang=js"
import style0 from "./AppCopyUrl.vue?vue&type=style&index=0&id=35a77dcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a77dcf",
  null
  
)

export default component.exports